export var ChatSignalREvent;
(function (ChatSignalREvent) {
    ChatSignalREvent["AppendedToChat"] = "AppendedToChat";
    ChatSignalREvent["MembersAppendedToChat"] = "MembersAppendedToChat";
    ChatSignalREvent["MembersExcludedFromChat"] = "MembersExcludedFromChat";
    ChatSignalREvent["ExcludedFromChat"] = "ExcludedFromChat";
    ChatSignalREvent["ChatParamsUpdated"] = "ChatParamsUpdated";
    ChatSignalREvent["ChatRenamed"] = "ChatRenamed";
    ChatSignalREvent["ReceiveMessage"] = "ReceiveMessage";
    ChatSignalREvent["MessageEdited"] = "MessageEdited";
    ChatSignalREvent["MessageRemoved"] = "MessageRemoved";
    ChatSignalREvent["MessagesMarkedAsRead"] = "MessagesMarkedAsRead";
})(ChatSignalREvent || (ChatSignalREvent = {}));
export var CHAT_SIGNAL_R_HUB_URL = 'chat';
